import React from 'react'
import FamilyMemberLabel from '../FamilyMemberLabel'
import $t from '../../../i18n'
import { formatNotification } from '../../../utils/notificationUtils'
import { useDispatch, useSelector } from 'react-redux'
import { t } from '@transifex/native'
import NotInsuredLabel from '../NotInsuredLabel'
import Actions from '../../../actions'

import './ActivityItem.css'

const ActivityItem = ({ item, index }) => {
  const dispatch = useDispatch()
  const members = useSelector(state => state.account?.members)
  const userDetails = useSelector(state => state.profile?.userDetails)

  const getNotificationMember = () => {
    if (item?.patientId?.toString() === userDetails?.id?.toString()) {
      return userDetails
    }
    return members?.find(
      member => member?.id?.toString() === item?.patientId?.toString()
    )
  }

  let notificationText = 'N/A'
  let notificationTitle = item?.title

  const notificationInfo = formatNotification(dispatch)(
    item?.navigation,
    item?.details,
    item?.id,
    item?.isRead,
    item?.title,
    item?.isPinned
  )

  notificationText = notificationInfo?.text
  const notificationAction = notificationInfo?.action

  const onClickNotification = () => {
    dispatch(
      Actions.createAction(Actions.CHOOSE_FAMILY_MEMBER, {
        member: getNotificationMember(),
      })
    )
    notificationAction()
  }

  return (
    <div
      className={item?.isRead ? 'feed-item' : 'feed-item unread'}
      data-pinned={item?.isPinned}
      key={index}
      onClick={item?.navigation ? onClickNotification : null}
    >
      <div className="feed-item-content">
        {item?.isPinned && <i className="icon-bookmark-fill" />}
        {item?.patientId && (
          <NotInsuredLabel
            className="family-member-container"
            patientId={item?.patientId}
          />
        )}
        {item?.patientId && (
          <FamilyMemberLabel
            className="family-member-container"
            patientId={item?.patientId}
          />
        )}
        <div className="category-header">
          {$t(`homeScreen.myActivity.categories.${item?.category}`)}{' '}
        </div>
        <div className="feed-item-text title">
          {' '}
          {item?.params
            ? t(notificationTitle, item?.params)
            : t(notificationTitle)}{' '}
        </div>
        <div className="feed-item-text">
          {' '}
          {item?.params
            ? t(notificationText, item?.params)
            : t(notificationText)}{' '}
        </div>
      </div>
      {!!notificationAction && (
        <span className="icon-arrow-bold-right icon-arrow" />
      )}
    </div>
  )
}

export default ActivityItem
